import React from "react";
import PropTypes from "prop-types";
import {
  IonAlert,
  IonCard,
  IonCardContent,
  IonItem,
  IonList,
} from "@ionic/react";
import CurrentPlayerIndicator from "../CurrentPlayerIndicator/CurrentPlayerIndicator";
import ScoreIndicator from "./sub/ScoreIndicator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

import "./style/MatchCard.scss";
import useAPI from "../../hooks/basic/useAPI";

function MatchCard({ match }) {
  const [editingPlayer, setEditingPlayer] = React.useState(null);
  const { callAPI } = useAPI();
  // check who is serving
  const servingPlayer = match?.currentStatus?.current_player;
  const servingPlayerId = servingPlayer?.athleteId;

  const selectServicePlayer = async (athleteId, athleteName) => {
    try {
      await callAPI({
        url: `/update-match-guest`,
        method: "POST",
        data: {
          matchId: match.id,
          athleteId,
          athleteName,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <IonCard className="MatchCard">
      <IonCardContent className="MatchCard_Content">
        <IonList>
          <IonItem>
            <div>
              {match?.team_a?.map((player) => (
                <div key={player.athleteId} className="MatchCard_Player">
                  <div className="MatchCard_Player_Indicator">
                    {player.athleteId === servingPlayerId && (
                      <CurrentPlayerIndicator />
                    )}
                  </div>
                  <span key={player.athleteId}>{player.name}</span>
                  {player.athleteId.includes("ospite_") && (
                    <span
                      className="MatchCard_Player_Ospite"
                      onClick={() => {
                        setEditingPlayer(player.athleteId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPen}
                        style={{
                          color: "var(--ion-color-primary)",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div style={{ marginLeft: "auto" }}>
              <ScoreIndicator
                completedSets={match?.currentStatus?.completedSets.team_a}
                data={match?.currentStatus?.team_a}
                status={match?.currentStatus}
              />
            </div>
          </IonItem>
          <IonItem
            className="MatchCard_Team_B"
            style={{
              "--border-style": "none",
            }}
          >
            <div>
              {match?.team_b?.map((player) => (
                <div key={player.athleteId} className="MatchCard_Player">
                  <div className="MatchCard_Player_Indicator">
                    {player.athleteId === servingPlayerId && (
                      <CurrentPlayerIndicator />
                    )}
                  </div>
                  <span key={player.athleteId}>{player.name}</span>
                  {player.athleteId.includes("ospite_") && (
                    <span
                      className="MatchCard_Player_Ospite"
                      onClick={() => {
                        setEditingPlayer(player.athleteId);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPen}
                        style={{
                          color: "var(--ion-color-primary)",
                          cursor: "pointer",
                        }}
                      />
                    </span>
                  )}
                </div>
              ))}
            </div>
            <div style={{ marginLeft: "auto" }}>
              <ScoreIndicator
                completedSets={match?.currentStatus?.completedSets.team_b}
                data={match?.currentStatus?.team_b}
                status={match?.currentStatus}
              />
            </div>
          </IonItem>
        </IonList>
      </IonCardContent>
      <IonAlert
        onIonAlertDidDismiss={() => {
          setEditingPlayer(null);
        }}
        isOpen={!!editingPlayer}
        trigger="present-alert"
        header="Nome ospite"
        buttons={[
          {
            text: "Annulla",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              setEditingPlayer(null);
            },
          },
          {
            text: "Salva",
            handler: (data) => {
              selectServicePlayer(editingPlayer, data[0]);
            },
          },
        ]}
        inputs={[
          {
            placeholder: "Nome",
          },
        ]}
      ></IonAlert>
    </IonCard>
  );
}

MatchCard.propTypes = {
  match: PropTypes.shape({
    team_a: PropTypes.arrayOf(
      PropTypes.shape({
        athleteId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    team_b: PropTypes.arrayOf(
      PropTypes.shape({
        athleteId: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    currentStatus: PropTypes.shape({
      phase: PropTypes.string.isRequired,
      team_a: PropTypes.shape({
        games: PropTypes.number.isRequired,
        tieBreakPoint: PropTypes.number,
        points: PropTypes.number.isRequired,
        sets: PropTypes.number.isRequired,
      }).isRequired,
      team_b: PropTypes.shape({
        games: PropTypes.number.isRequired,
        tieBreakPoint: PropTypes.number,
        points: PropTypes.number.isRequired,
        sets: PropTypes.number.isRequired,
      }).isRequired,
      current_player: PropTypes.shape({
        athleteId: PropTypes.string.isRequired,
      }),
      completedSets: PropTypes.shape({
        team_a: PropTypes.array.isRequired,
        team_b: PropTypes.array.isRequired,
      }),
    }).isRequired,
  }).isRequired,
};

export default MatchCard;
